// GENERATED by scripts/build-data.js - do not edit.

export const cases = {
    owid: () => import('./owid-cases.json'),
    acdc: () => import('./acdc-cases.json'),
};

export const country = {
    owid: {
        AGO: () => import('./owid-country/AGO.json'),
        BDI: () => import('./owid-country/BDI.json'),
        BEN: () => import('./owid-country/BEN.json'),
        BFA: () => import('./owid-country/BFA.json'),
        BWA: () => import('./owid-country/BWA.json'),
        CAF: () => import('./owid-country/CAF.json'),
        CIV: () => import('./owid-country/CIV.json'),
        CMR: () => import('./owid-country/CMR.json'),
        COD: () => import('./owid-country/COD.json'),
        COG: () => import('./owid-country/COG.json'),
        COM: () => import('./owid-country/COM.json'),
        CPV: () => import('./owid-country/CPV.json'),
        DJI: () => import('./owid-country/DJI.json'),
        DZA: () => import('./owid-country/DZA.json'),
        EGY: () => import('./owid-country/EGY.json'),
        ERI: () => import('./owid-country/ERI.json'),
        ESH: () => import('./owid-country/ESH.json'),
        ETH: () => import('./owid-country/ETH.json'),
        GAB: () => import('./owid-country/GAB.json'),
        GHA: () => import('./owid-country/GHA.json'),
        GIN: () => import('./owid-country/GIN.json'),
        GMB: () => import('./owid-country/GMB.json'),
        GNB: () => import('./owid-country/GNB.json'),
        GNQ: () => import('./owid-country/GNQ.json'),
        KEN: () => import('./owid-country/KEN.json'),
        LBR: () => import('./owid-country/LBR.json'),
        LBY: () => import('./owid-country/LBY.json'),
        LSO: () => import('./owid-country/LSO.json'),
        MAR: () => import('./owid-country/MAR.json'),
        MDG: () => import('./owid-country/MDG.json'),
        MLI: () => import('./owid-country/MLI.json'),
        MOZ: () => import('./owid-country/MOZ.json'),
        MRT: () => import('./owid-country/MRT.json'),
        MUS: () => import('./owid-country/MUS.json'),
        MWI: () => import('./owid-country/MWI.json'),
        NAM: () => import('./owid-country/NAM.json'),
        NER: () => import('./owid-country/NER.json'),
        NGA: () => import('./owid-country/NGA.json'),
        RWA: () => import('./owid-country/RWA.json'),
        SDN: () => import('./owid-country/SDN.json'),
        SEN: () => import('./owid-country/SEN.json'),
        SHN: () => import('./owid-country/SHN.json'),
        SLE: () => import('./owid-country/SLE.json'),
        SOM: () => import('./owid-country/SOM.json'),
        SSD: () => import('./owid-country/SSD.json'),
        STP: () => import('./owid-country/STP.json'),
        SWZ: () => import('./owid-country/SWZ.json'),
        SYC: () => import('./owid-country/SYC.json'),
        TCD: () => import('./owid-country/TCD.json'),
        TGO: () => import('./owid-country/TGO.json'),
        TUN: () => import('./owid-country/TUN.json'),
        TZA: () => import('./owid-country/TZA.json'),
        UGA: () => import('./owid-country/UGA.json'),
        ZAF: () => import('./owid-country/ZAF.json'),
        ZMB: () => import('./owid-country/ZMB.json'),
        ZWE: () => import('./owid-country/ZWE.json'),
    },
    acdc: {
        AGO: () => import('./acdc-country/AGO.json'),
        BDI: () => import('./acdc-country/BDI.json'),
        BEN: () => import('./acdc-country/BEN.json'),
        BFA: () => import('./acdc-country/BFA.json'),
        BWA: () => import('./acdc-country/BWA.json'),
        CAF: () => import('./acdc-country/CAF.json'),
        CIV: () => import('./acdc-country/CIV.json'),
        CMR: () => import('./acdc-country/CMR.json'),
        COD: () => import('./acdc-country/COD.json'),
        COG: () => import('./acdc-country/COG.json'),
        COM: () => import('./acdc-country/COM.json'),
        CPV: () => import('./acdc-country/CPV.json'),
        DJI: () => import('./acdc-country/DJI.json'),
        DZA: () => import('./acdc-country/DZA.json'),
        EGY: () => import('./acdc-country/EGY.json'),
        ERI: () => import('./acdc-country/ERI.json'),
        ESH: () => import('./acdc-country/ESH.json'),
        ETH: () => import('./acdc-country/ETH.json'),
        GAB: () => import('./acdc-country/GAB.json'),
        GHA: () => import('./acdc-country/GHA.json'),
        GIN: () => import('./acdc-country/GIN.json'),
        GMB: () => import('./acdc-country/GMB.json'),
        GNB: () => import('./acdc-country/GNB.json'),
        GNQ: () => import('./acdc-country/GNQ.json'),
        KEN: () => import('./acdc-country/KEN.json'),
        LBR: () => import('./acdc-country/LBR.json'),
        LBY: () => import('./acdc-country/LBY.json'),
        LSO: () => import('./acdc-country/LSO.json'),
        MAR: () => import('./acdc-country/MAR.json'),
        MDG: () => import('./acdc-country/MDG.json'),
        MLI: () => import('./acdc-country/MLI.json'),
        MOZ: () => import('./acdc-country/MOZ.json'),
        MRT: () => import('./acdc-country/MRT.json'),
        MUS: () => import('./acdc-country/MUS.json'),
        MWI: () => import('./acdc-country/MWI.json'),
        NAM: () => import('./acdc-country/NAM.json'),
        NER: () => import('./acdc-country/NER.json'),
        NGA: () => import('./acdc-country/NGA.json'),
        NaN: () => import('./acdc-country/NaN.json'),
        RWA: () => import('./acdc-country/RWA.json'),
        SDN: () => import('./acdc-country/SDN.json'),
        SEN: () => import('./acdc-country/SEN.json'),
        SOM: () => import('./acdc-country/SOM.json'),
        SSD: () => import('./acdc-country/SSD.json'),
        STP: () => import('./acdc-country/STP.json'),
        SWZ: () => import('./acdc-country/SWZ.json'),
        SYC: () => import('./acdc-country/SYC.json'),
        TCD: () => import('./acdc-country/TCD.json'),
        TGO: () => import('./acdc-country/TGO.json'),
        TUN: () => import('./acdc-country/TUN.json'),
        TZA: () => import('./acdc-country/TZA.json'),
        UGA: () => import('./acdc-country/UGA.json'),
        ZAF: () => import('./acdc-country/ZAF.json'),
        ZMB: () => import('./acdc-country/ZMB.json'),
        ZWE: () => import('./acdc-country/ZWE.json'),
    },
};

export const metric = {
    owid: {
        aged_65_older: () => import('./owid-metric/aged_65_older.json'),
        aged_70_older: () => import('./owid-metric/aged_70_older.json'),
        cardiovasc_death_rate: () => import('./owid-metric/cardiovasc_death_rate.json'),
        continent: () => import('./owid-metric/continent.json'),
        diabetes_prevalence: () => import('./owid-metric/diabetes_prevalence.json'),
        excess_mortality: () => import('./owid-metric/excess_mortality.json'),
        excess_mortality_cumulative: () => import('./owid-metric/excess_mortality_cumulative.json'),
        excess_mortality_cumulative_absolute: () => import('./owid-metric/excess_mortality_cumulative_absolute.json'),
        excess_mortality_cumulative_per_million: () => import('./owid-metric/excess_mortality_cumulative_per_million.json'),
        extreme_poverty: () => import('./owid-metric/extreme_poverty.json'),
        female_smokers: () => import('./owid-metric/female_smokers.json'),
        gdp_per_capita: () => import('./owid-metric/gdp_per_capita.json'),
        handwashing_facilities: () => import('./owid-metric/handwashing_facilities.json'),
        hosp_patients: () => import('./owid-metric/hosp_patients.json'),
        hosp_patients_per_million: () => import('./owid-metric/hosp_patients_per_million.json'),
        hospital_beds_per_thousand: () => import('./owid-metric/hospital_beds_per_thousand.json'),
        human_development_index: () => import('./owid-metric/human_development_index.json'),
        icu_patients: () => import('./owid-metric/icu_patients.json'),
        icu_patients_per_million: () => import('./owid-metric/icu_patients_per_million.json'),
        life_expectancy: () => import('./owid-metric/life_expectancy.json'),
        location: () => import('./owid-metric/location.json'),
        male_smokers: () => import('./owid-metric/male_smokers.json'),
        median_age: () => import('./owid-metric/median_age.json'),
        new_cases: () => import('./owid-metric/new_cases.json'),
        new_cases_per_million: () => import('./owid-metric/new_cases_per_million.json'),
        new_cases_smoothed: () => import('./owid-metric/new_cases_smoothed.json'),
        new_cases_smoothed_per_million: () => import('./owid-metric/new_cases_smoothed_per_million.json'),
        new_deaths: () => import('./owid-metric/new_deaths.json'),
        new_deaths_per_million: () => import('./owid-metric/new_deaths_per_million.json'),
        new_deaths_smoothed: () => import('./owid-metric/new_deaths_smoothed.json'),
        new_deaths_smoothed_per_million: () => import('./owid-metric/new_deaths_smoothed_per_million.json'),
        new_people_vaccinated_smoothed: () => import('./owid-metric/new_people_vaccinated_smoothed.json'),
        new_people_vaccinated_smoothed_per_hundred: () => import('./owid-metric/new_people_vaccinated_smoothed_per_hundred.json'),
        new_tests: () => import('./owid-metric/new_tests.json'),
        new_tests_per_thousand: () => import('./owid-metric/new_tests_per_thousand.json'),
        new_tests_smoothed: () => import('./owid-metric/new_tests_smoothed.json'),
        new_tests_smoothed_per_thousand: () => import('./owid-metric/new_tests_smoothed_per_thousand.json'),
        new_vaccinations: () => import('./owid-metric/new_vaccinations.json'),
        new_vaccinations_smoothed: () => import('./owid-metric/new_vaccinations_smoothed.json'),
        new_vaccinations_smoothed_per_million: () => import('./owid-metric/new_vaccinations_smoothed_per_million.json'),
        people_fully_vaccinated: () => import('./owid-metric/people_fully_vaccinated.json'),
        people_fully_vaccinated_per_hundred: () => import('./owid-metric/people_fully_vaccinated_per_hundred.json'),
        people_vaccinated: () => import('./owid-metric/people_vaccinated.json'),
        people_vaccinated_per_hundred: () => import('./owid-metric/people_vaccinated_per_hundred.json'),
        population: () => import('./owid-metric/population.json'),
        population_density: () => import('./owid-metric/population_density.json'),
        positive_rate: () => import('./owid-metric/positive_rate.json'),
        reproduction_rate: () => import('./owid-metric/reproduction_rate.json'),
        stringency_index: () => import('./owid-metric/stringency_index.json'),
        tests_per_case: () => import('./owid-metric/tests_per_case.json'),
        tests_units: () => import('./owid-metric/tests_units.json'),
        total_boosters: () => import('./owid-metric/total_boosters.json'),
        total_boosters_per_hundred: () => import('./owid-metric/total_boosters_per_hundred.json'),
        total_cases: () => import('./owid-metric/total_cases.json'),
        total_cases_per_million: () => import('./owid-metric/total_cases_per_million.json'),
        total_deaths: () => import('./owid-metric/total_deaths.json'),
        total_deaths_per_million: () => import('./owid-metric/total_deaths_per_million.json'),
        total_tests: () => import('./owid-metric/total_tests.json'),
        total_tests_per_thousand: () => import('./owid-metric/total_tests_per_thousand.json'),
        total_vaccinations: () => import('./owid-metric/total_vaccinations.json'),
        total_vaccinations_per_hundred: () => import('./owid-metric/total_vaccinations_per_hundred.json'),
        weekly_hosp_admissions: () => import('./owid-metric/weekly_hosp_admissions.json'),
        weekly_hosp_admissions_per_million: () => import('./owid-metric/weekly_hosp_admissions_per_million.json'),
        weekly_icu_admissions: () => import('./owid-metric/weekly_icu_admissions.json'),
        weekly_icu_admissions_per_million: () => import('./owid-metric/weekly_icu_admissions_per_million.json'),
    },
    acdc: {
        location: () => import('./acdc-metric/location.json'),
        new_cases: () => import('./acdc-metric/new_cases.json'),
        new_cases_per_million: () => import('./acdc-metric/new_cases_per_million.json'),
        new_cases_smoothed: () => import('./acdc-metric/new_cases_smoothed.json'),
        new_cases_smoothed_per_million: () => import('./acdc-metric/new_cases_smoothed_per_million.json'),
        new_deaths: () => import('./acdc-metric/new_deaths.json'),
        new_deaths_per_million: () => import('./acdc-metric/new_deaths_per_million.json'),
        new_deaths_smoothed: () => import('./acdc-metric/new_deaths_smoothed.json'),
        new_deaths_smoothed_per_million: () => import('./acdc-metric/new_deaths_smoothed_per_million.json'),
        new_people_vaccinated_smoothed: () => import('./acdc-metric/new_people_vaccinated_smoothed.json'),
        new_people_vaccinated_smoothed_per_hundred: () => import('./acdc-metric/new_people_vaccinated_smoothed_per_hundred.json'),
        new_tests: () => import('./acdc-metric/new_tests.json'),
        new_tests_per_thousand: () => import('./acdc-metric/new_tests_per_thousand.json'),
        new_tests_smoothed: () => import('./acdc-metric/new_tests_smoothed.json'),
        new_tests_smoothed_per_thousand: () => import('./acdc-metric/new_tests_smoothed_per_thousand.json'),
        population: () => import('./acdc-metric/population.json'),
        positive_rate: () => import('./acdc-metric/positive_rate.json'),
        tests_per_case: () => import('./acdc-metric/tests_per_case.json'),
        total_boosters: () => import('./acdc-metric/total_boosters.json'),
        total_boosters_per_hundred: () => import('./acdc-metric/total_boosters_per_hundred.json'),
        total_cases: () => import('./acdc-metric/total_cases.json'),
        total_cases_per_million: () => import('./acdc-metric/total_cases_per_million.json'),
        total_deaths: () => import('./acdc-metric/total_deaths.json'),
        total_deaths_per_million: () => import('./acdc-metric/total_deaths_per_million.json'),
        total_tests: () => import('./acdc-metric/total_tests.json'),
        total_tests_per_thousand: () => import('./acdc-metric/total_tests_per_thousand.json'),
    },
};

